import { useLocation, Link } from 'react-router-dom';

const ProductItem = ({ product }) => {
    const location = useLocation();

    return (
        <Link to={`${location.pathname}/${product.slug}`} className="product-item">
            <div className="product-item__image">
                <img src={product.icon} alt={product.title} />
            </div>
            <div className="product-item__name">
                <p className="body2">{product.title}</p>
            </div>
        </Link>
    );
};

export default ProductItem;
